/*
 * BoldStuff infinite scroll — lazy-loads paginated pages on scroll.
 *
 * Looks for elements with [data-infinite-scroll] that carry:
 *   data-next-url : URL of the next page
 *   data-target   : CSS selector of the list to append new items into
 *
 * On scroll near the sentinel it fetches the next page, appends the matching
 * list's children into the live list, then reads the next URL from the fetched
 * page. When no next URL remains it stops and removes the sentinel.
 *
 * After appending it dispatches a `bs:items-appended` event on document so card
 * sliders (and any other per-item JS) can re-initialise the new nodes.
 */
(function () {
  function setup(el) {
    if (el.__bsInfiniteInit) return;
    el.__bsInfiniteInit = true;

    var nextUrl = el.getAttribute('data-next-url');
    var targetSel = el.getAttribute('data-target');
    var target = targetSel ? document.querySelector(targetSel) : null;
    var sentinel = el.querySelector('.bs-infinite-sentinel');
    var loader = el.querySelector('.bs-infinite-loader');

    if (!nextUrl || !target || !sentinel) return;

    var loading = false;
    var done = false;
    var observer = null;

    function showLoader(on) {
      if (loader) loader.style.display = on ? 'flex' : 'none';
    }

    function cleanup() {
      done = true;
      if (observer) observer.disconnect();
      if (sentinel && sentinel.parentNode) {
        sentinel.parentNode.removeChild(sentinel);
      }
      showLoader(false);
    }

    function load() {
      if (loading || done || !nextUrl) return;
      loading = true;
      showLoader(true);

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          // Append the new page's items into the live list.
          var newList = targetSel ? doc.querySelector(targetSel) : null;
          if (newList) {
            var frag = document.createDocumentFragment();
            var kids = Array.prototype.slice.call(newList.children);
            kids.forEach(function (node) {
              frag.appendChild(document.importNode(node, true));
            });
            target.appendChild(frag);
          }

          // Work out the URL of the page after this one.
          var marker = doc.querySelector('[data-infinite-scroll]');
          var newNext = marker ? marker.getAttribute('data-next-url') : null;

          loading = false;
          showLoader(false);

          // Let card sliders / other per-item scripts hook the new nodes.
          document.dispatchEvent(new CustomEvent('bs:items-appended', {
            detail: { target: target }
          }));

          if (newNext && newNext !== nextUrl) {
            nextUrl = newNext;
            // If the sentinel is still near the viewport (short pages / tall
            // screens), keep going so the user isn't stuck.
            requestAnimationFrame(maybeLoad);
          } else {
            cleanup();
          }
        })
        .catch(function () {
          // Network/parse error — stop spinner, allow a later retry on scroll.
          loading = false;
          showLoader(false);
        });
    }

    function maybeLoad() {
      if (done || loading) return;
      var rect = sentinel.getBoundingClientRect();
      if (rect.top <= window.innerHeight + 400) load();
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) load();
        });
      }, { rootMargin: '400px 0px' });
      observer.observe(sentinel);
    } else {
      window.addEventListener('scroll', maybeLoad, { passive: true });
      window.addEventListener('resize', maybeLoad, { passive: true });
    }

    // Initial check in case the page is short enough that the sentinel is
    // already on screen.
    maybeLoad();
  }

  function init() {
    var els = document.querySelectorAll('[data-infinite-scroll]');
    Array.prototype.forEach.call(els, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
